var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main-cates"},_vm._l((_vm.selfServiceList),function(item,index){return _c('div',{key:index,staticClass:"item-block",on:{"click":function($event){return _vm.handleJump(item)}}},[_c('img',{staticClass:"imgCon",attrs:{"src":item.imgUrl}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }